var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb-item',{class:_vm.dragClass,style:(_vm.itemStyle)},[_c('a',{class:_vm.dragClass,attrs:{"href":_vm.href,"draggable":"false","target":_vm.target}},[_vm._v(_vm._s(_vm.module.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }